import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private RT: Router) {}

  canActivate() {
    const jwt = localStorage.getItem('token');
    if (jwt) {
      const user = this.getUserInfo(jwt);
      Sentry.setUser({ id: user.userId, company: user.companyId });
      return true;
    } else {
      this.RT.navigate(['']);
      return false;
    }
  }

  private getUserInfo(jwt: string) {
    const base64Url = jwt.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }
}
